import React from 'react';
import { Box } from '@mui/material';
import CIHAChartsContainer from '../Common/CIHAChartsContainer';
import PacientProfileWrapper from './index';

const PacientProfile = () => {
    return (
        <Box>
            <Box className="content">
                <CIHAChartsContainer
                    title={'Perfil do Paciente'}
                    className="services-container-dashboards"
                >
                    <PacientProfileWrapper />
                </CIHAChartsContainer>
            </Box>
        </Box>
    );
};

export default PacientProfile;
